// Import hooks.
import {
	useInputAddress,
	UseInputAddressParameters,
	UseInputAddressResults,
} from '@app/hooks/view/input';
// Import props.
import {
	InputAddressLocationProps,
	InputAddressWithoutInputTextBoxProps,
} from '@app/props';
// Import api models.
import {
	GpsCoordinates,
} from '@app/models/api';

interface UseInputAddressLocationParameters{
	addressInputParameters: UseInputAddressParameters,
	addressLocation?: GpsCoordinates;
	requestToChangeLocation?: () => void
}

type UseInputAddressLocationResults = UseInputAddressResults<InputAddressLocationProps>;

const useInputAddressLocation = (params: UseInputAddressLocationParameters): UseInputAddressLocationResults => {

	// #region exported methods

	/**
	 * Returns props for form input. 
	 **/
	const applyAddressLocationProps = (): InputAddressLocationProps & InputAddressWithoutInputTextBoxProps => {
		// First apply the address props.
		let addressInputProps: InputAddressWithoutInputTextBoxProps = applyProps();
		// Then apply the address location props.
		return {
			...addressInputProps,
			isChangeLocationDisabled: areGpsCoordinatesMissing(params.addressLocation) || other.doesInputHaveChanges || !other.isInputValid,
			onRequestToChangeLocation: params.requestToChangeLocation,
		}
	};

	// #endregion exported methods
	/**
	 * Checks to see if the gps coordinates exist or have a value of 0
	 * @param gpsCoordinates
	 */
	const areGpsCoordinatesMissing = (gpsCoordinates: GpsCoordinates | undefined): boolean => {
		const lat: number | undefined = gpsCoordinates?.latitude ?? undefined;
		const lng: number | undefined = gpsCoordinates?.longitude ?? undefined;

		return lat === 0 || lng === 0 || lat === undefined || lng === undefined;
	}

	// #region variables

	// Instantiate the 'address' input.
	const { applyProps, ...other } = useInputAddress({
		...params.addressInputParameters
	});

	// #endregion variables


	return {
		applyProps: applyAddressLocationProps,
		...other,
	};
}

// Export parameters.
export {
	UseInputAddressLocationParameters,
}

// Export results.
export {
	UseInputAddressLocationResults,
}

export default useInputAddressLocation;